//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { bus } from '~/assets/js/eventBus'
import hotSearch from '~/components/common/hotSearch.vue'
import { gatClick } from '~/utils/utils'
export default {
  components: {
    hotSearch
  },
  props: {
    huntObj: {
      type: Object,
      default: () => {}
    },
    type: {
      // 1-pc;2-wap
      type: String,
      default: '1'
    },
    autoshow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      myEntry: '', // 用户输入的内容
      listData: [],
      searchshow: false,
      lan: this.$store.state.LanguageCode,
      scene: 0,
      sceneQuery: this.$route.query.scene ? parseInt(this.$route.query.scene) : 0,
      device: 'pc'
    }
  },
  mounted () {
    if (this.$route.name == 'lang-search.html' && this.$route.query.keyword) this.myEntry = decodeURIComponent(this.$route.query.keyword).substring(0, 30)
    document.addEventListener(
      'click',
      () => {
        setTimeout(() => {
          this.searchshow = false
          this.$emit('headClose')
        }, 100)
      },
      { passive: true }
    )

    bus.$on('searchfocuse', (ret) => {
      if (ret === 'home') {
        this.searchshow = false
      }
    })

    this.DealClientWidth()

    console.log('scene', this.scene)
    console.log('this.$route.name', this.$route.name)
    console.log('sceneQuery', this.sceneQuery)
  },
  methods: {
    searchFn (val, type = 'focus') {
      // 点击搜索
      if (!this.myEntry) return
      try {
        this.matomofn('Search', {
          type: '搜索',
          value: '顶部搜索框'
        })
        if (this.$store.state.cookieHost.includes('fxeyetips.com') || this.$store.state.cookieHost.includes('fxeyevip.com')) {
          window?.fbq('track', 'search_broker_name')
        }
        gatClick()
      } catch (err) {
        console.log('顶部搜索统计报错' + err)
        // this.$fxlog('顶部搜索统计报错' + err)
      }
      this.$Cookie.set('searchurl', this.$store.state.allHost, {
        path: '/',
        domain: this.$store.state.cookieHost
      })

      const _keyord = this.$route.query.keyword ? decodeURIComponent(this.$route.query.keyword) : ''
      if (_keyord && this.$route.name == 'lang-search.html') {
        console.log('this.myEntry', this.myEntry)
        this.$store.commit('setSearchWord', this.myEntry)
        bus.$emit('currentPageSearch', this.myEntry)
        window.scrollTo(0, 0)
        this.searchshow = false
      } else {
        setTimeout(() => {
          // 新增一个头，SearchPosition(0 首页大的搜索框  1 顶部搜索框)
          const a = document.createElement('a')
          let rt = ''
          if (val) {
            rt = encodeURIComponent(val.replace('<span>', '').replace('</span>', '').substring(0, 30))
          } else {
            rt = encodeURIComponent(this.myEntry.substring(0, 30))
          }
          a.target = '_blank'
          a.href = `https://www.${this.$store.state.newhost}.com/${this.$store.state.LanguageCode}/search.html?keyword=${rt}&SearchPosition=1${this.sence !== 0 ? '&scene=' + this.scene : ''}`
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        }, 500)
      }
    },
    searchData () {
      // 搜索
      if (!this.myEntry) {
        this.getfocus()
        return
      }
      let time = null
      // const that = this
      // 闭包原理，返回一个函数
      return (() => {
        // 如果定时器存在则清空定时器
        if (time) {
          clearTimeout(time)
        }
        // 设置定时器，规定时间后执行真实要执行的函数
        time = setTimeout(() => {
          // 此箭头函数里的this指向btn这个按钮
          // fn.call(this, arguments) // 改变真实要执行函数的this指向，原submit函数里面的this指向window
          // this.searchInput()
          this.checkpinzhuanfn(() => {
            this.searchInput()
          })
        }, 500)
      })()
    },
    searchInput () {
      this.$api.common
        .CV3(
          {
            content: this.myEntry,
            project: 1,
            type: 1,
            scene: this.sceneQuery || this.scene
          },
          {
            Routes: 'wikibizagg$search_intellisense2'
          }
        )
        .then((ret) => {
          if (this.scene === 3 || this.scene === 4 || this.sceneQuery == 3 || this.sceneQuery == 4) {
            const res = ret?.wikibizagg?.search_intellisense2?.data?.content
            res &&
              res.forEach((item) => {
                item.title = item?.title?.replace(this.myEntry, `<span>${this.myEntry}</span>`)
              })
            if (res && res.length > 0) this.searchshow = true
            this.listData = res
          } else {
            const res = ret?.wikibizagg?.search_intellisense2?.data?.items
            res &&
              res.forEach((item) => {
                item.showname = item?.name?.replace(this.myEntry, `<span>${this.myEntry}</span>`)
              })
            if (res && res.length > 0) this.searchshow = true
            this.listData = res
            this.$nextTick(() => {
              this.fixedsearchtipwisth()
              // setImg()
            })
          }
          // console.log('this.listData: ', this.listData)
        })
    },
    getfocus () {
      bus.$emit('searchfocuse', 'head')
      // 聚焦
      if (this.myEntry) {
        this.searchInput()
      } else {
        this.$api.wikifxranking
          .rankinghomeClient({
            code: '82100019',
            app: 1,
            type: 1,
            size: 10
          })
          .then((res) => {
            const arr = res && res.ranking && res.ranking.slice(0, 10)
            arr.forEach((item) => {
              item.code = item.traderCode
              item.showname = item.shortName ? item.shortName : item.localShortName
              item.name = item.shortName ? item.shortName : item.localShortName
            })
            const articletime = new Date().getTime() - new Date('2023-9-28 23:59:59').getTime()
            if (articletime < 0 && (this.$store.state.CountryCode == 'cn' || this.$store.state.CountryCode == 'hk')) {
              const STARTRADER = {
                ico: 'https://eimgjys.fxeyee.com/ico/637853008942373282/FXT637853008942373282_137265.png_wiki-template-global',
                code: '2277676718',
                traderCode: '2277676718',
                showname: 'STARTRADER',
                name: 'STARTRADER',
                color: '#2BB351',
                annotation: this.$t('31188')
              }
              if (arr.length >= 10) {
                arr[9] = STARTRADER
              }
            }
            this.listData = [...arr]
            this.$nextTick(() => {
              this.searchshow = true
              this.fixedsearchtipwisth()
            })
          })
      }
    },
    async toDealer (code, name) {
      console.log('toDealer', code)
      // 人气排行跳转
      // this.sensorTrackHead(this.$route, 'focus', this.myEntry, name)
      if (!code) return
      this.matomofn('Search', {
        type: '搜索',
        value: '区分位子'
      })
      // this.$Cookie.set('searchurl', this.$store.state.allHost, { path: '/', domain: this.$store.state.cookieHost })
      const a = document.createElement('a')
      a.target = '_blank'
      a.href = `https://www.${this.$store.state.newhost}.com/${this.$store.state.LanguageCode}/dealer/${code}.html`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      const params = {
        project: 1,
        type: 1,
        content: name,
        CountryCode: this.$store.state.CountryCode,
        LanguageCode: this.$store.state.LanguageCode
      }
      const headers = {
        SearchPosition: '2',
        SearchUrl: this.$store.state.allHost
      }
      await this.$api.search.switch(params, headers).then((res) => {
        // window.open(`/${this.$store.state.LanguageCode}/dealer/${code}.html`)
      })
      // .catch((err) => {
      //   console.log(err)
      // })
    },
    toDiscover (dataType, postid, userid, lan, postlan) {
      return ''
    },
    checkpinzhuanfn (fn) {
      // 判断是否为品专
      this.$api.common
        .CV3(
          {
            content: this.myEntry,
            adPtn: 1
          },
          {
            Routes: 'search$checkpinzhuan'
          }
        )
        .then((res) => {
          console.log(res?.search?.checkpinzhuan?.data?.code, 999)
          if (!res?.search?.checkpinzhuan?.data?.adFlag) {
            // 不是品专
            fn()
          } else {
            // window.open(`/${this.$store.state.LanguageCode}/search.html?keyword=${this.keyword}&SearchPosition=0`)
            this.searchFn('', 'click')
          }
        })
    },
    fixedsearchtipwisth () {
      try {
        const hotdom = document.querySelectorAll('.headsearchhot')
        const outerdom = document.querySelectorAll('.headsearchpop')
        if (hotdom?.length > 0) {
          hotdom[0].style.width = '390px'
        }
        const doms = document.querySelectorAll('.pcSearch')
        if (doms?.length > 0) {
          const totalwidth = outerdom?.length > 0 ? outerdom[0]?.clientWidth : 9999
          // 页面尺寸800-1000时，悬浮框的最大宽度是550px；1000+以上尺寸最大宽度是663px
          const maxwidth = this.device === 'md' ? 540 : 630
          if (totalwidth > maxwidth) {
            const fixedwidth = 50
            doms.forEach((it, k) => {
              const tarderdom = doms[k]?.querySelectorAll('.hunt-p')
              const atondom = doms[k]?.querySelectorAll('.hunt-label')
              if (tarderdom?.length > 0 && atondom?.length > 0) {
                tarderdom[0]?.classList?.remove('long')
                tarderdom[0].style.width = ''
                if (doms[k]?.clientWidth > totalwidth) {
                  tarderdom[0].style.width = totalwidth - atondom[0].clientWidth - fixedwidth + 'px'
                  tarderdom[0]?.classList?.add('long')
                }
              }
            })
          } else {
            // 清空前一次计算的宽度
            doms.forEach((it, k) => {
              const tdom = doms[k].querySelectorAll('.hunt-p')
              if (tdom?.length > 0) {
                tdom[0].style.width = ''
              }
            })
          }
        }
        if (hotdom?.length > 0 && outerdom?.length > 0) {
          hotdom[0].style.width = outerdom[0]?.clientWidth + 'px'
        }
      } catch {}
    },
    DealClientWidth () {
      const clientWidth = document.documentElement.clientWidth || document.body.clientWidth
      if (clientWidth >= 1200) {
        this.device = 'pc'
      } else if (clientWidth >= 1000) {
        this.device = 'lg'
      } else if (clientWidth >= 800) {
        this.device = 'md'
      } else {
        this.device = 'sm'
      }
    }
  }
}
